import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/BasketStepLocal/" );
const basketInstance = new HttpService( "umbraco/api/Basket/" );

/* eslint-disable arrow-body-style */
/* eslint-disable object-shorthand */

/**
 * Gets the current user's basket id
 */
export const getBasketId = () => {
  return instance.get( "GetBasketId" );
};

/**
 * Removes an order line from the basket.
 * @param {*} orderLineId The order line to remove.
 */
export const removeItem = ( orderLineId ) => {
  console.log( `removing item: ${orderLineId}` );
  return instance.delete( "RemoveItem", {
    orderLineId
  } );
};

/**
 * Check if any bookings in the basket are valid
 */
export const validateBookings = () => {
  return instance.get( "ValidateBookings" );
};

/**
 * Check if any addresses in the basket are valid
 */
export const validateAddresses = () => {
  return instance.get( "ValidateAddresses" );
};

/**
 * Get the product data for products in the basket
 */
export const getBasketProducts = () => {
  return instance.get( "GetBasketProducts" );
};

/**
 * Checks to see if the basket has any order lines.
 */
export const basketHasOrderLines = () => {
  return instance.get( "BasketHasOrderLines" );
};

/**
 * The basket is replaced with a new order header
 * if successful, this returns the basketID
 */
export const getNewBasket = () => {
  return basketInstance.get( "GetNewBasket" );
};
